
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("calendar/manageimport_list",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"items") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":14},"end":{"line":1,"column":566}}})) != null ? stack1 : "")
    + " ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexrow class=\"border-pane\" data-fw-onclick=\"openImportDetail|"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" style=\"cursor:pointer;margin-bottom:var(--space-xs);align-items:center\"><flexauto><p><strong>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"eventCount") : depth0), depth0))
    + " "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"manageimport.eventsimported",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":217},"end":{"line":1,"column":257}}})) != null ? stack1 : "")
    + "</strong></p> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"info") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":271},"end":{"line":1,"column":320}}})) != null ? stack1 : "")
    + " <p class=\"sub4\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"date") : depth0), depth0))
    + "</p></flexauto><icon style=\"background:var(--fwPrimary25);border-radius:var(--space-xs);width:36px;height:36px;display:flex;align-items:center;justify-content:center;flex-shrink:0\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"emoji") : depth0), depth0))
    + "</icon></flexrow> ";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p class=\"sub4\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"info") : depth0), depth0))
    + "</p>";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"emptystateblock flexcenter flexcol\" style=\"padding:var(--space-xl) 0\"><icon style=\"font-size:48px\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"calendar.ic_calendar_import",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":687},"end":{"line":1,"column":728}}}))
    + "</icon><h2>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"manageimport.empty.title",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":739},"end":{"line":1,"column":776}}})) != null ? stack1 : "")
    + "</h2><p class=\"sub4\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"manageimport.empty.text",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":797},"end":{"line":1,"column":833}}})) != null ? stack1 : "")
    + "</p></div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"items") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":851}}})) != null ? stack1 : "")
    + " ";
},"useData":true});
export default TPL;